import { styleLink } from "superlinear-react-ui";

const StyledA = styleLink("a");

export default StyledA;
